import React, { Fragment, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hook'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { useGetAllWidgetsQuery } from '../../../../../../../redux/slices/widget/apiWidgetSlice'
import { AUTOCOMPLETEOPTIONS, Element, IMAGEDURATION, Props, Source, STATECITY } from '../../../../../../../redux/slices/content/contentModels'
import { setContentSource } from '../../../../../../../redux/slices/content/contentSlice'
import { FullAddress, Widget, WidgetInput } from '../../../../../../../redux/slices/widget/widgetModel'
import { extractYouTubeVideoId, getSectionIcon } from '../../../../../../../redux/slices/editor/editorModels'
import Swal from 'sweetalert2'
import moment from 'moment'
import {yupResolver} from '@hookform/resolvers/yup'
import {useForm, SubmitHandler } from 'react-hook-form'
import * as yup from 'yup'
import { Autocomplete, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material'

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import jsonCities from '../../../../../../../data/citiesminified-au.json';
import { getCountryCode } from '../../../../../../../redux/slices/device/deviceModels'






const DEFAULT_ENDDATETIME     = dayjs().add(1, 'day')
const DEFAULT_ENDDATETIME_STR = DEFAULT_ENDDATETIME.format('YYYY-MM-DD HH:mm:ss')


const schema = yup.object().shape({    
    url: yup.string(),
    videoUrl: yup.string(),
    sheetId: yup.string(),
    location: yup.string(),
    end_time: yup.string(),

    // width: yup.number(),
    // height: yup.number(),
})

// -----------------------
export const ModalEditWidget: React.FC<Props> = ({className=""}) => {
  const dispatch = useAppDispatch()
  // ------------------------------------
  const currContentPersistor = useAppSelector(state => state.persistor._content.currContent)
  const currSectId = useAppSelector(state => state.content.currSectionId)  

  const selectedWidget = useAppSelector(state => state.editor.currWidget)  
  // console.log("selectedWidget: ", selectedWidget);

  const [recentSect, setRecentSect] = useState<Element | undefined>(undefined)
  // console.log("recentSect: ", recentSect);

  const [url, setUrl] = useState<string>("https://superbolt.com.au");
  const [videoUrl, setVideoUrl] = useState<string>("https://www.youtube.com/watch?v=GYQJdSomIAc");
  const [sheetId, setSheetId] = useState<string>("https://docs.google.com/spreadsheets/d/e/2PACX-1vSIIuull8RqJTauafjelYc5UvvUfJZ46J_eP9-4iJdrr2iuDH5ItPet8iBAffWjoScVxodZXCRz-sij/pubhtml");
  const [location, setLocation] = useState<string>("Melbourne");
  const [endDateTime, setEndDateTime] = useState<Dayjs | null>(DEFAULT_ENDDATETIME);

  // -----------------------------   
  const [address, setAddress] = useState<FullAddress | null>(null);
  const [loadingAddress, setLoadingAddress] = useState<boolean>(true);
  const [errorAddress, setErrorAddress] = useState<string | null>(null);

  // console.log("jsonCities:", jsonCities)

  let addrList: string[] = [];
  if (jsonCities instanceof Array) {
    addrList = jsonCities?.reduce((result: string[], city : any)=> {
                  const cityStates = city.states?.reduce((res: string[], state: any)=>{
                                        const cityNameList = state.cities.map((c: STATECITY) => c.name + ", AU")  
                                        return [...res, ...cityNameList]
                                      }, []);
                  return [...result, ...cityStates];                  // return [...cityStates];
                }, [])
  }  
  addrList = Array.from(new Set(addrList));
  // console.log("addrList: ", addrList)

  
  const [flatProps, setFlatProps] = useState<AUTOCOMPLETEOPTIONS>({
    options: !addrList? [] : addrList.map((option, ind) => {
      return (option.charAt(0).toUpperCase() + option.slice(1))
    })
  });
  // console.log("flatProps:", flatProps)   


  const { 
    register, 
    setValue,
    getValues,
    handleSubmit,
    reset,
    watch,
    setError,
    formState:{
        errors,
        isDirty,
        
        isLoading,         
        isValid,   
        isSubmitting,
        isSubmitSuccessful          
    }
  } = useForm<WidgetInput>({
    resolver: yupResolver(schema),
    defaultValues:{            
      url     : "https://superbolt.com.au",
      videoUrl: "https://www.youtube.com/watch?v=GYQJdSomIAc",
      sheetId : "https://docs.google.com/spreadsheets/d/e/2PACX-1vSIIuull8RqJTauafjelYc5UvvUfJZ46J_eP9-4iJdrr2iuDH5ItPet8iBAffWjoScVxodZXCRz-sij/pubhtml",
      location: "Melbourne",
      end_time: DEFAULT_ENDDATETIME_STR,    
      
      // width : recentSect?recentSect.w : 150, 
      // height: recentSect?recentSect.h : 150
    }
  }) 
  //---------------------------------------------------- 
  
  // console.log("location:", "'"+location+"'")   
  // console.log('watch', watch())
  // console.log('watch(["location"]):', watch(["location", "url", "sheetId", "end_time"]))    
  // console.log("watch param_source:", watch("param_source"))
  

  //---------------------------------------------------- 
  // const handleOrderChange = (inputOrder: number) =>{
      
  //     if (inputOrder <= 0){
  //         inputOrder = 1
  //     }else if (inputOrder > maxOrder){
  //         inputOrder = maxOrder     
  //     }

  //     reset({
  //         ...selectedLayer,
  //         order: inputOrder,
  //         param_source: [{
  //             ...selectedLayer?.param_source[0],
  //             duration: (duration * 1000)
  //         }]
  //     })
  // }

  // ---------------------------------------
  const addNewSource = (selectedWidget: Widget, recentSect: Element | undefined, extraParams : any = {}) => {
    
    var sourceList: Source[] = []
    var sourceOrder: number = 1
    recentSect?.sources.map((src)=>{
      sourceList =[...sourceList, {...src, order: src.order}]
      if(sourceOrder <= src.order) sourceOrder = src.order+1
    })  

    // create new source for widget
    // -----------------------------
    var newSource: Source = {
      source_list_id: Math.random().toString(36).slice(0,12).replace('0.', '').toUpperCase(),
      element_id: Math.random().toString(36).slice(0,12).replace('0.', '').toUpperCase(),
      source_id: "",
      order:  sourceOrder++,
      duration_override: -1, 
      
      source: null,
      type: "widget",          
      param_source: [{
          type: "widget",              
          widget_id : selectedWidget.id,
          title: selectedWidget.name.toLowerCase(),
          paramValue: [{
            ...selectedWidget.parameter,
            ...extraParams,                            
          }],

          duration: IMAGEDURATION,
          delay: 0,
          volume: null,

          bg_color:  sourceList.length> 0 ? sourceList[0].param_source[0].bg_color : "#00000000",
          fill_to:   sourceList.length> 0 ? sourceList[0].param_source[0].fill_to: "fit",
          alignment: sourceList.length> 0 ? sourceList[0].param_source[0].alignment: "center"
      }]
    }
    
    sourceList = [newSource, ...sourceList ] //do not use push    
    // console.log("sourceList:", sourceList);

    dispatch(setContentSource(sourceList)) 
  }
  
  //---------------------------------------------------- 
  const formSubmitHandler: SubmitHandler<WidgetInput> = async (widgetInp: WidgetInput) => {        
   
    // console.log('widgetInp:',widgetInp);

    // const recentSect = currContentPersistor.elements.find((ele)=> {return ele.element_id === currSectId})
    // console.log("recentSect:", recentSect)   


    // Init extraParams
    let extraParams: any =  { 
      width: recentSect?.w, 
      height: recentSect?.h
    }

    try{

      // Genearate necessary params
      // ----------------------                      
      if (["weather", "weather forecast"].includes(selectedWidget.name.toLowerCase())){                      
        extraParams = { ...extraParams,
                      location : widgetInp.location                                    
                    }
      }else if (["qr code"].includes(selectedWidget.name.toLowerCase())){
        const extractedVideoID = extractYouTubeVideoId(widgetInp.url);
        extraParams = { ...extraParams,
                        colorDark : "#ffffff",
                        colorLight: "#000000",
                        ...(extraParams.width >= extraParams.height 
                            ? {width: extraParams.height, height: extraParams.height}  
                            : {width: extraParams.width,  height: extraParams.width}                                            
                        ),                                        
                        url       : widgetInp.url ? widgetInp.url : "superbolt.com.au",                                                                              
                      }
      }else if (["count down"].includes(selectedWidget.name.toLowerCase())){
        const endDateTime = widgetInp.end_time ? moment(widgetInp.end_time, "YYYYY-MM-DD HH:mm:ss") : moment();
        extraParams = { ...extraParams,
                        targetDate  : endDateTime.format("YYYY-MM-DD"),
                        targetTime  : endDateTime.format("HH:mm:ss")
                      }       
      }else if (["youtube"].includes(selectedWidget.name.toLowerCase())){
        const extractedVideoID = extractYouTubeVideoId(widgetInp.videoUrl);

        extraParams = { ...extraParams,
                      videoId : extractedVideoID? extractedVideoID : widgetInp.videoUrl,
                      autoPlay: 1,
                      width: recentSect?.w, 
                      height: recentSect?.h
                    }                  
      }else if (["google sheet"].includes(selectedWidget.name.toLowerCase())){                        
        let extractedSheetID = widgetInp.sheetId ? widgetInp.sheetId.match(/\/d\/e\/(.+)\//) : ""

        extraParams = { ...extraParams,
                      sheetId : extractedSheetID? extractedSheetID[1] : widgetInp.sheetId,
                      width   : "100%",
                      height  : "100%",                                    
                      showHeader: true, 
                      showSheet : true,                                    
                    }
      }
      // console.log("extraParams after ---:", extraParams)

      addNewSource(selectedWidget, recentSect, extraParams);   
        
    }catch(error){
      // console.log("error", error)
      Swal.fire(
          'Widget ',
          'There is something wrong during the process!',
          'error'
      )            
    
    }
  }


  // ---------------------------
  // useEffect(() => {
  //   // [...jsonCities]?.forEach((country:any) => country.states)
  //   // console.log("jsonCities:", jsonCities)
  //   // console.log("jsonStates:", jsonStates)

  //   let addrList: string[] = [];
  //   if (jsonCities instanceof Array) {
  //     addrList = jsonCities?.reduce((result: string[], city : any)=> {
  //                   // console.log("city:", city)  
  //                   const cityStates = city.states?.reduce((res: string[], state: any)=>{
  //                                         // console.log("state.cities: ", state.cities)
  //                                         const cityNameList = state.cities.map((c: STATECITY) => c.name)  
  //                                         // console.log("cityNameList: ", cityNameList)
  //                                         return [...res, ...cityNameList]
  //                                       }, []);

  //                   return [...result, ...cityStates];
  //                 }, [])
  //   }
  //   console.log("addrList: ", addrList)
    

  //   // setAddressList(addrList);
  //   // setFlatProps({
  //   //   options: !addrList? [] : addrList.map((option, ind) => {
  //   //     return (option.charAt(0).toUpperCase() + option.slice(1))
  //   //   })
  //   // })
  // },[jsonCities, jsonStates])

  useEffect(() => {
    setRecentSect(currContentPersistor.elements.find((ele)=> {return ele.element_id === currSectId}))

  }, [currContentPersistor, currSectId]);

  // -------------------------------
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${position.coords.latitude}&lon=${position.coords.longitude}`
            );
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // console.log("data: ", data);

            setAddress({
              city: data.address.city || data.address.town || data.address.village || '',
              suburb: data.address.suburb || '',
              country: data.address.country || '',
              postcode: data.address.postcode || '',
              road: data.address.road || '',
              state: data.address.state || '',
            });
            setLocation         (`${data.address.suburb || data.address.state || ""}, ${data.address.country_code.toUpperCase()}`);
            setValue('location', `${data.address.suburb || data.address.state || ""}, ${data.address.country_code.toUpperCase()}`);
          } catch (err: any) {
            setErrorAddress(err.message);
          } finally {
            setLoadingAddress(false);
          }
        },
        (err) => {
          setErrorAddress(err.message);
          setLoadingAddress(false);
        }
      );
    } else {
      setErrorAddress('Geolocation is not supported by this browser.');
      setLoadingAddress(false);
    }
  }, []);
    
  // --------------------------------------------------------
  return (<>
  <div className={`modal fade ${className}`} tabIndex={-1} 
    id='kt_modal_edit_widget'
  >
    <div className="modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content mh-600px pb-5">
        <div className='d-flex justify-content-between align-items-center bg-gradient-primary py-2 px-3 rounded-top'>          
          <div className=''>
            <KTSVG path='/media/icons/duotune/general/gen025.svg' className='svg-icon-2x text-light' />              
            <span className='text-light fs-4 ms-2'>Edit Widget </span>
          </div>
          <div className="float-end btn-group btn-group-sm" role="group" >        
              <button
                  className='btn btn-icon btn-close'
                  data-bs-dismiss="modal" 
                  aria-label="Close"
              >                
              </button>
          </div>
        </div>
        <div 
          className='h-100 w-100 px-8 pt-10 pb-5'
          style={{maxHeight:"100%", overflowX:"hidden"}}
        >
          <div className='container'>
            <div className='row'>
              <div className='col-s-12 col-lg-3 text-center'>
                <div className="symbol symbol-125px mb-4">
                  <div className="symbol-label fs-2 fw-bold text-success">
                    {getSectionIcon(selectedWidget.name.toLowerCase(), "text-gray-700 svg-icon-3x ms-2", "w-50px d-flex flex-center")}
                  </div>
                </div>
                <div>{selectedWidget.name}</div>
              </div>
              <div className='col-s-12 col-lg-9'>

                <form id="frm-edit-widget" className='form'  
                  onSubmit={handleSubmit(formSubmitHandler)}
                >              
                  <div className="mb-3"
                    hidden={! ["qr code"].includes(selectedWidget.name.toLowerCase())}                                    
                  >
                    <TextField 
                        {...register("url")} 
                        value={url}
                        type="string"
                        label="URL" 
                        placeholder='https://superbolt.com.au'
                        fullWidth 
                        margin='dense'
                        variant='outlined' 
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                            setUrl(e.target.value) 
                            setValue('url', e.target.value) 
                        }}
                        error={!! errors.url}
                        helperText={`${errors.url?.message ?? ''}`}
                        // focused={watch(`param_source[0][duration]`) ? true:false}                                    
                    />
                  </div>
                  <div className="mb-3"
                    hidden={! ["youtube"].includes(selectedWidget.name.toLowerCase())}                                    
                  >
                    <TextField 
                        {...register("videoUrl")} 
                        value={videoUrl}
                        type="string"
                        label="Video URL" 
                        placeholder='https://www.youtube.com/watch?v=GYQJdSomIAc'
                        fullWidth 
                        margin='dense'
                        variant='outlined' 
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                            setVideoUrl(e.target.value) 
                            setValue('videoUrl', e.target.value) 
                        }}
                        error={!! errors.videoUrl}
                        helperText={`${errors.videoUrl?.message ?? ''}`}
                        // focused={watch(`param_source[0][duration]`) ? true:false}                                    
                    />
                  </div>
                  <div className="mb-3"
                    hidden={! ["google sheet"].includes(selectedWidget.name.toLowerCase())}                                    
                  >
                    <TextField 
                        {...register("sheetId")} 
                        value={sheetId}
                        type="string"
                        label="Sheet ID" 
                        placeholder='https://docs.google.com/spreadsheets/d/e/2PACX-1vSIIuull8RqJTauafjelYc5UvvUfJZ46J_eP9-4iJdrr2iuDH5ItPet8iBAffWjoScVxodZXCRz-sij/pubhtml'
                        fullWidth 
                        margin='dense'
                        variant='outlined' 
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => {
                            setSheetId(e.target.value) 
                            setValue('sheetId', e.target.value) 
                        }}
                        error={!! errors.url}
                        helperText={`${errors.url?.message ?? ''}`}
                        // focused={watch(`param_source[0][duration]`) ? true:false}                                    
                    />
                  </div>
                  <div className="mb-3"
                    hidden={! ["weather", "weather forecast"].includes(selectedWidget.name.toLowerCase())}                  
                  >
                    {/* <div>                      
                      {loadingAddress && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                          Please wait...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                      {errorAddress && <p>Error: {errorAddress}</p>}                      
                      {!loadingAddress && address && (
                        <div className='mb-5'>
                          <div><i className='bi bi-pin-map-fill me-2'></i>Current location: </div>
                          <div>{address.road}, {address.suburb}, {address.state} {address.postcode}, {address.city}, {address.country}</div>                          
                        </div>
                      )}
                    </div> */}
                    <div className=''>
                      <Autocomplete
                        {...flatProps}              
                        id="location"
                        value={location}
                        placeholder='Melbourne,AU'
                        freeSolo
                        selectOnFocus
                        includeInputInList
                        sx={{
                          border: "1px solid #C4C4C4",
                          borderRadius: "5px",
                          padding: "5px",
                          "& .MuiOutlinedInput-root": {
                              border: "2px solid #000000",
                              borderRadius: "5",
                              padding: "0"
                          },
                          "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                              border: "1px solid #eee"
                          }
                        }}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option}>
                              {option}
                            </li>
                          )
                        }}
                        onChange={(event, value) => {
                          // console.log("on value change: ", value)
                          setLocation(value? value.trim() : "")
                          setValue('location', value? value.trim() : "")
                        }}              
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            placeholder='Enter your suburb or state'
                            variant="standard"
                            fullWidth
                            sx={{
                              border: "0"
                            }}
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              type: 'search',
                              startAdornment: (
                                <InputAdornment position="start">
                                  <i className="fa fa-search ms-3 me-1 text-black" aria-hidden="true"></i>
                                </InputAdornment>
                              ),
                              endAdornment:(
                                <InputAdornment position="end">
                                  <button type="button" className={`btn btn-sm btn-primary p-2 px-3 rounded-0 tooltip-bottom`}
                                    style={{marginLeft:"0px", marginRight:"1px", borderTopLeftRadius:"0", borderBottomLeftRadius:"0"}}
                                    // style={{marginLeft:"0px", marginRight:"-35px", borderTopLeftRadius:"0", borderBottomLeftRadius:"0"}}
                                    data-tooltip-content="Current Signage Device Location(s)"  
                                    onClick={() => {
                                      setLocation("Device Location");
                                      setValue('location', "Device Location");
                                    }}                          
                                  >
                                    <KTSVG path='/media/icons/duotune/electronics/elc003.svg' className='svg-icon-2x m-0'/>
                                  </button>
                                  <button type="button" className={`btn btn-sm btn-primary p-2 px-3 rounded-0 rounded-end tooltip-bottom`}
                                    style={{marginLeft:"0px", marginRight:"-35px", borderTopLeftRadius:"0", borderBottomLeftRadius:"0"}}
                                    data-tooltip-content="Current Laptop Location"  
                                    onClick={() => {
                                      setLocation(address? `${(address.suburb || address.state)}, ${getCountryCode(address.country)}` : "");
                                      setValue('location', address? `${(address.suburb || address.state)}, ${getCountryCode(address.country)}` : "");
                                    }}                          
                                  >
                                    <KTSVG path='/media/icons/duotune/general/gen018.svg' className='svg-icon-2x m-0'/>
                                  </button>
                                </InputAdornment>
                              )
                            }}
                            onChange={(event) => {                              
                              setLocation(event.target.value? event.target.value : "")
                              setValue('location', event.target.value? event.target.value : "")
                            }}                            
                          />
                        )}                        
                      />                      
                      
                    </div>
                  </div>
                  <div className="mb-3" 
                    hidden={! ["count down"].includes(selectedWidget.name.toLowerCase())}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                          components={[
                          // 'DateTimePicker',
                          'MobileDateTimePicker',
                          // 'DesktopDateTimePicker',
                          // 'StaticDateTimePicker',
                          ]}
                      >
                          
                          <DemoItem >
                              <MobileDateTimePicker 
                                  className='mb-5'
                                  label="End Date & Time" 
                                  value={endDateTime}
                                  minDate={dayjs()}
                                  views={['year', 'month', 'day', 'hours', 'minutes']}
                                  defaultValue={dayjs()} 
                                  onChange={(newVal)=>{ 
                                      setEndDateTime(newVal)
                                      setValue("end_time", newVal? newVal.format('YYYY-MM-DD HH:mm:ss'):"")
                                  }}
                              />                              
                          </DemoItem>                                    
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  {/* <div className="mb-3">
                      <TextField 
                          {...register("order")}                                     
                          type="number"
                          label="Order" 
                          fullWidth 
                          margin='dense'
                          variant='outlined'                                     
                          hidden={true}
                          InputLabelProps={{ shrink: true }}
                          // onChange={(e) => handleOrderChange(parseInt(e.target.value))}
                          // error={!! errors.order}
                          // helperText={`${errors.order?.message ?? `Min: 1, Max: ${maxOrder}`}`}
                          // disabled = {maxOrder === 1? true: false}
                      />
                  </div> */}
                  {/* <div className="mb-3" hidden={true}>
                      <TextField 
                          {...register(`param_source.0.duration`)} 
                          // value={duration * 1000}
                          type="number"
                          label="Duration (sec)" 
                          fullWidth 
                          margin='dense'
                          variant='outlined' 
                          InputLabelProps={{ shrink: true }}
                          // error={!! errors.group_name}
                          // helperText={`${errors.group_name?.message ?? ''}`}
                          // focused={watch(`param_source[0][duration]`) ? true:false}                                    
                      />
                  </div> */}
                  
                  <div className="pt-8 text-end row">
                      <div className='col-12 text-end'>
                          <button type="submit" className="btn btn-primary w-100" 
                              // data-bs-dismiss="offcanvas"
                              aria-label="Close"
                              data-bs-dismiss="modal" 
                              // disabled={isSubmitting || !isValid}
                          >                                
                              <i className="fa fa-save fs-3 me-1 mt-n1"></i>
                              Add Widget
                          </button>
                      </div>
                      
                  </div>
                  {/*
                  <button type="button" 
                      className="btn btn-icon btn-light position-absolute bottom-0 end-0 me-7 mb-8" 
                      data-bs-dismiss="offcanvas"
                      data-kt-drawer-dismiss="true"
                  >
                      <KTSVG
                          path='/media/icons/duotune/arrows/arr001.svg'
                          className='svg-icon svg-icon-1x'
                      />
                  </button>
                      */}
                </form>
              </div>
            </div>
          </div>
          
        </div>
      </div>  
    </div>
  </div>
</>
)
}
